import { useLayoutEffect, useState } from "react";
import { BrowserRouterProps, Router } from "react-router-dom";
// @ts-ignore
import {BrowserHistory} from "history";
import customHistory from "./RouteHistory";

interface Props extends BrowserRouterProps {
    history: BrowserHistory;
}
export const CustomRouter = ({ basename, history, children }: Props) => {
    const [state, setState] = useState({
        action: history.action,
        location: history.location,
    });
    useLayoutEffect(() => history.listen(setState), [history]);
    return (
        <Router
            navigator={customHistory}
            location={state.location}
            navigationType={state.action}
            children={children}
            basename={basename}
        />
    );
};